import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { 
    User, 
    Globe,
    MapPin,
    CheckCircle,
    AlertCircle
} from 'lucide-react';
import '../create_user/CreateUserPage'; // You might want to rename this CSS file
import DashboardBase from "../DashboardBase";

const CreateFundManagerPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        website: ''
    });

    const [validation, setValidation] = useState({
        name: true,
        address: true,
        website: true
    });

    const validateForm = () => {
        const newValidation = {
            name: formData.name.length >= 2,
            address: formData.address.length >= 5,
            website: formData.website.length >= 6,
        };

        setValidation(newValidation);
        return Object.values(newValidation).every(Boolean);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setError(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            setError('Please correct the validation errors.');
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/fund-manager`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to create fund manager');
            }

            setSuccess(true);
            setTimeout(() => {
                navigate('/fund-manager');
            }, 2000);

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <DashboardBase
            page="home"
            content={
                <div className="create-user-page">
                    <div className="dashboard-page">
                        <div className="dashboard-header">
                            <h1>Create New Fund Manager</h1>
                        </div>

                        <div className="content-card">
                            {success ? (
                                <div className="success-message">
                                    <CheckCircle className="success-icon" />
                                    <p>Fund Manager created successfully! Redirecting...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="create-fund-manager-form">
                                    {error && (
                                        <div className="error-message">
                                            <AlertCircle className="error-icon" />
                                            {error}
                                        </div>
                                    )}

                                    <div className="form-group">
                                        <label htmlFor="name">Fund Manager Name</label>
                                        <div className="input-wrapper">
                                            <User className="input-icon" />
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className={!validation.name ? 'invalid' : ''}
                                                placeholder="Enter fund manager name"
                                                required
                                            />
                                        </div>
                                        {!validation.name && (
                                            <span className="validation-message">
                                                Name must be at least 2 characters
                                            </span>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <div className="input-wrapper">
                                            <MapPin className="input-icon" />
                                            <input
                                                type="text"
                                                id="address"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                className={!validation.address ? 'invalid' : ''}
                                                placeholder="Enter address"
                                                required
                                            />
                                        </div>
                                        {!validation.address && (
                                            <span className="validation-message">
                                                Address must be at least 5 characters
                                            </span>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="website">Website</label>
                                        <div className="input-wrapper">
                                            <Globe className="input-icon" />
                                            <input
                                                type="text"
                                                id="website"
                                                name="website"
                                                value={formData.website}
                                                onChange={handleChange}
                                                className={!validation.website ? 'invalid' : ''}
                                                placeholder="Enter website URL"
                                                required
                                            />
                                        </div>
                                        {!validation.website && (
                                            <span className="validation-message">
                                                Please enter a valid website URL
                                            </span>
                                        )}
                                    </div>

                                    <div className="form-actions">
                                        <button 
                                            type="button" 
                                            className="button secondary"
                                            onClick={() => navigate('/fund-managers')}
                                        >
                                            Cancel
                                        </button>
                                        <button 
                                            type="submit" 
                                            className="button primary"
                                            disabled={loading}
                                        >
                                            {loading ? 'Creating...' : 'Create Fund Manager'}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default CreateFundManagerPage;
